module.exports = __webpack_public_path__ + "static/img/feature_02.2873ca9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/active/ares/secondAnniversary/3/feature_02.png
// module id = /YvV
// module chunks = 10